// CANONICAL COPY (GH #7115). src/constants/obligations/obl-segregation-duties.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-segregation-duties',
  title: 'Review segregation of duties',
  description:
    'Verify that conflicting duties are identified and appropriately segregated. Review access rights to confirm no single person has excessive privileges.',
  category: 'governance',
  scfIds: ['SCF-GOV-003'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Segregation of duties policy is published' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
